import React,{Fragment} from 'react'

function Footer() {
  return (
    <Fragment>
        <footer className='mt-5'>
            <h5 className='text-center fw-light'>&copy; Ideas Digitales 2022</h5>
        </footer>
    </Fragment>
  )
}

export default Footer